import { ReactNode, useEffect, useState } from "react";
import { createPortal } from "react-dom";

export const HeaderToolBarActions = ({ children }: { children?: ReactNode }) => {
    const [actionsContainer, setActionContainer] = useState<Element | null>();

    useEffect(() => {
        setActionContainer(document.querySelector("#header-toolbar-actions"));
    }, []);

    if (!actionsContainer) {
        return null;
    }

    return createPortal(children, actionsContainer);
};
